
import {Component} from 'vue-property-decorator'
import { BasePropertyMaintenanceSystemsComponent, RequiredProjections } from '../base/BaseMixins'
import PropertyMap from "@/components/properties/PropertyMap.vue"

@RequiredProjections("propertyMaintenanceSystemSummary")
@Component({components: {PropertyMap}})
export default class PropertyMaintenanceSystemName extends BasePropertyMaintenanceSystemsComponent {
}
